import { render } from "./trending-up.svg?vue&type=template&id=e3722740?inline"
const script = {}
script.render = render

export default script